<div class="w-full">
  <h3>Agregar adjuntos</h3>
  <p class="font-thin italic">
    * Formatos soportados: *.jpg *.png *.jpeg *.pdf *.docx
    <cite></cite>
  </p>
  <div class="flex justify-center items-center">
    <div
      class="h-14 px-3 border border-primary-900 text-primary-900 rounded-md cursor-pointer flex justify-center items-center transition-all duration-300 hover:bg-primary-900 hover:text-white mr-4"
      (click)="file.click()"
    >
      <p>
        <i class="pi-cloud-upload pi"></i>
        Subir archivo
      </p>
    </div>
    <input
      hidden
      type="file"
      #file
      (change)="uploadFile($event)"
      accept="image/jpg, image/png, image/gif, image/jpeg, .pdf, .docx, video/mp4"
    />
  </div>
</div>
<div class="w-full hide" [ngClass]="{ show: adjuntos.length > 0 }">
  <div>
    <div class="grid grid-cols-12 gap-5 pt-3">
      @for (adjunto of adjuntos; track $index) {
      <div
        class="lg:col-span-4 md:col-span-6 sm:col-span-12 col-span-12 flex justify-start items-center"
      >
        <div class="w-16 h-full relative flex justify-center items-center">
          @if (esImagen(adjunto)) {
          <p-image
            id="image"
            [src]="adjunto.adjunto ? url + adjunto.adjunto : 'svg/no-file.svg'"
            alt="Image"
            width="64"
            [preview]="true"
            class="rounded-lg"
            appendTo="body"
          />
          } @else {
          <img
            [src]="toggleImagen(adjunto)"
            alt="Image"
            width="64"
            class="rounded-lg"
          />
          }
        </div>
        <div class="pl-3 w-full">
          <p class="m-0 p-0">
            <small>
              {{
                adjunto
                  ? adjunto.nombre_archivo
                  : 'No se selecciono ningún archivo'
              }}
            </small>
          </p>
          <p
            class="text-blue-600 cursor-pointer"
            (click)="
              onEmitirImagen(
                adjunto.adjunto ? url + adjunto.adjunto : 'svg/no-file.svg'
              )
            "
          >
            Seleccionar
          </p>
        </div>
        <div>
          <img
            pTooltip="Quitar"
            src="svg/close.svg"
            alt="Cerrar"
            width="30"
            class="ml-2 cursor-pointer img-spin"
            (click)="eliminarArchivo(adjunto.id)"
          />
        </div>
      </div>
      }
    </div>
  </div>
</div>
